





















import Vue, { PropOptions } from 'vue';

interface LocalProps {
  value: PropOptions;
  label: PropOptions;
  img: PropOptions;
}

export default Vue.extend({
  name: 'HMImageCheckBoxGroup',
  props: {
    value: {
      type: Boolean,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    img: {
      type: [String, Object],
      default: null,
    },
  } as LocalProps,
});
